import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

/**
 * 店舗検索リクエストパラメータの型定義
 */
export interface ClubSearchParams {
  is_search_nearby: boolean; // 現在地からの検索
  region_code?: number; // エリアID
  club_name_or_address?: string; // 店舗名・住所
  tag_list?: number[]; // タグIDリスト (絞り込み条件となるタグ)
  member_id: string; // 会員番号
}

/**
 * お気に入り店舗登録リクエストパラメータの型定義
 */
export interface FavoriteClubParams {
  member_id: string; // 会員番号
  club_id: number; // 店舗ID
  is_favorite: boolean; // お気に入り登録フラグ (true: 登録, false: 取消)
}

/**
 * 予約(Reservation)関連のAPIサービス
 */
const reservationService = () => {
  return {
    getClubOptions: () => {
      return apiClient.get(`${API_BASE_ADDRESS}/visitor/yoyaku/club-options`);
    },
    searchClubs: (params: ClubSearchParams) => {
      return apiClient.post(`${API_BASE_ADDRESS}/visitor/yoyaku/visitor-club`, params);
    },
    getOneClub: (action: any) =>
      apiClient.get(`${API_BASE_ADDRESS}/visitor/yoyaku/club-information?club_id=${action.clubId}`),
  };
};

export default reservationService;
